import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useToast } from '@shared/hooks/use-toast';
import { IntegrationsApiAdapter } from '../adapters/IntegrationsApiAdapter';
import { CHATBY_TOKEN_QUERY_KEY } from './useChatbyToken';
import { INTEGRATIONS_QUERY_KEY } from './useIntegrations';

export const useActivateChatby = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('integrationsModule');
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new IntegrationsApiAdapter(httpClient);

  return useMutation({
    mutationFn: () => adapter.getChatbyToken(),
    onSuccess: (data) => {
      queryClient.setQueryData([CHATBY_TOKEN_QUERY_KEY], data);
      queryClient.invalidateQueries({ queryKey: [INTEGRATIONS_QUERY_KEY] });
      toast({
        title: t('activate.success'),
        description: t('activate.successDescription'),
        variant: 'default',
      });
    },
    onError: (error: { statusCode?: number; message?: string }) => {
      const isForbidden = error.statusCode === 403;
      toast({
        title: isForbidden ? t('token.forbidden') : t('activate.error'),
        description: !isForbidden ? error.message : undefined,
        variant: 'destructive',
      });
    },
  });
};
